import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { View } from '../view/view';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ServerService {

  private url = environment.url;

  private token = "";
   
  isLoading = new Subject<boolean>();

  constructor(private httpClient:HttpClient, private view:View) { }

  private createHeaders(){
    let headers:HttpHeaders = new HttpHeaders();
    headers = headers.set('Access-Control-Allow-Origin','*');
    headers = headers.set('Content-Type','application/json');
    
    if (this.token) {
      headers = headers.set('Authorization', 'Bearer ' + this.token);
    }

    return headers;
  }

  public createExtraRequestHeaders(){
    let headers:HttpHeaders = new HttpHeaders();
    headers = headers.set('Access-Control-Allow-Origin','*');
    headers = headers.set('Access-Control-Allow-Origin','Content-Type: multipart/form-data');
    if (this.token) {
      headers = headers.set('Authorization', 'Bearer ' + this.token);
    }
    return headers;
  }


  //TRATAR QUANDO NÂO FOR SUCESSO AQUI PARA EMITIR A MENAGEM AO USUARIO...
  get(router:String, params:any = {}):Observable<any>{

    let finalUrl = this.url + "/"+ router;

    let headers = this.createHeaders();


    // return this.httpClient.get(finalUrl, { headers:headers, params:params})
    this.isLoading.next(true);
    return Observable.create(
      (obs) => {
        this.httpClient.get(finalUrl, { headers:headers, params:params}).subscribe(
          (result) => {this.processRequest(obs, result)}, 
          (err) => { this.processErro(obs,err)},
        )
      }
    );
  }


  post(router:String, data:any) :Observable<any>{
    let finalUrl = this.url + "/"+ router;

    let headers = this.createHeaders();

    let body = JSON.stringify(data);

    this.isLoading.next(true);
    // return this.httpClient.post(finalUrl, body, { headers:headers});
    return Observable.create(
      (obs) => {
        this.httpClient.post(finalUrl, body, { headers:headers}).subscribe(
          (result) => {this.processRequest(obs, result)}, 
          (err) => { this.processErro(obs,err)},
        )
      }
    );
  }

  processErro(obs:any, err:any){
    this.isLoading.next(false);
    console.error(err);
    if(err.status && err.status == 400){
      this.view.showMessage("Sem autorização. "+err.error.message, "danger");
    }else if(err.status && err.status == 401){
      this.view.showMessage("Sem autorização. Caso necessário fazer novamente o login.", "danger");
    }else{
      this.view.showMessage("Erro a realizar a requisição ao servidor", "danger");
    }
    obs.error(err);
  }
  processRequest(obs:any, result:any){
    this.isLoading.next(false);
      if ('sucesso' in result){
        if(!result['sucesso']){
          this.view.showMessage(result['mensagem'],"danger");
          obs.error(result['mensagem']);
        }else{
          obs.next(result);
        }
      }else{
        obs.next(result);
      }
      obs.complete();
  }

  getURL(){
    return this.url;
  }

  setTokenAcesso(tokenAcesso){
    this.token = tokenAcesso;
  }
}
